function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid_1_"
}, React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(21.622 289.473)"
}, "400,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(67.394 350)"
}, "0"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(21.92 225.089)"
}, "800,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(15.382 159.93)"
}, "1,200,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(14.85 94.606)"
}, "1,600,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(45.723 36.626)"
}, "GDP"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(91 16.626)"
}, "Gross Domestic Product by Year"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(11.323 52.226)"
}, "(million $)"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(91 378.753)"
}, "1997"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(164.7 378.753)"
}, "2000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(315.923 378.753)"
}, "2005"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(467.755 378.753)"
}, "2010"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(618.98 378.753)"
}, "2015"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(694.402 378.753)"
}, "2018"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M181.3 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M331.9 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M482.4 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M633 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 26.2h632.3V350H91z"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 220.5h632.8"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 285.2h632.8"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 155.7h632.8"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 91h632.8"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Line_2_",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M91 251.2l30.1-5.7 30.1-5.7 30.1-9.3 30.2-5.6 30.1-2.3 30.1-6.8 30.1-12.4 30.2-13 30.1-16 30.1-15.1 30.1-9.5 30.2 11.9 30.1-11.9 30.1-15.3 30.1-13 30.2-14.7 30.1-10.2 30.1-.5 30.1.6 30.2-14.6 30.1-19.6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Top_x5F_label_1_"
}, React.createElement("path", {
  fill: "#fff",
  d: "M481.9 53.6h224v22h-224z"
}), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(515.093 68.407)"
}, "Mostly Rural counties"), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(658.593 68.407)"
}, "5.6 %"));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Title_x5F_label"
}, React.createElement("path", {
  fill: "#3a4a9f",
  stroke: "#fff",
  strokeMiterlimit: 10,
  d: "M423.1 21.9h282.8v22H423.1z"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(444.799 36.678)"
}, "Share of Texas GDP by Type of County"));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "Bottom_x5F_label_1_"
}, React.createElement("path", {
  fill: "#fb7d74",
  d: "M481.9 230.9h224v22h-224z"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(498.647 245.728)"
}, "Mostly Urban counties"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(648.447 245.728)"
}, "94.4 %"));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "Barchart_2_"
}, React.createElement("path", {
  id: "White",
  fill: "#fff",
  d: "M735.4 62.5h30.2V350h-30.2z"
}), React.createElement("path", {
  id: "Red",
  fill: "#fb7d74",
  d: "M735.4 78.6h30.2V350h-30.2z"
}));

var SvgS3BDesktopColors = function SvgS3BDesktopColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "viz",
    x: 0,
    y: 0,
    viewBox: "0 0 800 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default "data:image/svg+xml;base64,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";
export { SvgS3BDesktopColors as ReactComponent };